// extracted by mini-css-extract-plugin
export default {"idCard":"Idcard_idCard__Mwue2","carousel":"Idcard_carousel__UApRn","idSection":"Idcard_idSection__FuVJe"};